import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="w-full mx-auto px-4 md:px-6 py-12 md:py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        <div className="lg:col-span-1 flex flex-col gap-4">
          <div className="flex items-center gap-2">
            <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center font-heading text-lg">
              漫
            </span>
            <span className="font-heading text-xl text-background-50">36漫画网</span>
          </div>
          <p className="text-sm text-background-300 leading-relaxed">
            36漫画网致力于提供高品质的漫画全集下拉式免费在线阅读服务。海量漫画资源实时更新，支持中文在线阅读，让你随时畅享漫画世界的精彩。
          </p>
        </div>

        <nav className="flex flex-col gap-3" aria-label="漫画分类">
          <h4 className="font-heading text-base text-background-50">漫画分类</h4>
          <ul className="grid grid-cols-2 gap-2">
            {categories.map((c) => (
              <li key={c.slug}>
                <Link to={`/category/${c.slug}`} className="text-sm text-background-300 hover:text-accent-300 transition-colors">
                  {c.name}漫画
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <nav className="flex flex-col gap-3" aria-label="快捷链接">
          <h4 className="font-heading text-base text-background-50">快捷链接</h4>
          <ul className="flex flex-col gap-2">
            <li><Link to="/" className="text-sm text-background-300 hover:text-accent-300 transition-colors">网站首页</Link></li>
            <li><Link to="/category/all" className="text-sm text-background-300 hover:text-accent-300 transition-colors">全部漫画</Link></li>
            <li><Link to="/category/lianai" className="text-sm text-background-300 hover:text-accent-300 transition-colors">恋爱漫画</Link></li>
            <li><Link to="/about" className="text-sm text-background-300 hover:text-accent-300 transition-colors">关于我们</Link></li>
          </ul>
        </nav>

        <div className="flex flex-col gap-3">
          <h4 className="font-heading text-base text-background-50">联系我们</h4>
          <ul className="flex flex-col gap-2 text-sm text-background-300">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line w-4 h-4 flex items-center justify-center text-accent-400" aria-hidden="true" />
              service@36mang.com
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-wechat-line w-4 h-4 flex items-center justify-center text-accent-400" aria-hidden="true" />
              公众号：36漫画网
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-phone-line w-4 h-4 flex items-center justify-center text-accent-400" aria-hidden="true" />
              400-888-0000
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-800">
        <div className="w-full mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-background-400">
            © 2026 36漫画网 All Rights Reserved · 本站漫画仅供学习交流，版权归原作者所有
          </p>
          <div className="flex items-center gap-4 text-xs text-background-400">
            <span>友情链接</span>
            <Link to="/about" className="hover:text-accent-300 transition-colors">免责声明</Link>
            <Link to="/about" className="hover:text-accent-300 transition-colors">版权投诉</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}